import { SupportedDeviceType } from '@enums/supported-device-type.enum';
import { Icon, Radio, RadioGroup, useTranslation } from '@testsigma/atoms';

interface IOSDeviceTypeSelectionProps {
  supportedDeviceType: SupportedDeviceType;
  onChangeSupportedDeviceType: (
    supportedDeviceType: SupportedDeviceType,
  ) => void;
  isUploadVersion: boolean;
}

export const IOSDeviceTypeSelectionPanel: React.FC<
  IOSDeviceTypeSelectionProps
> = ({ supportedDeviceType, onChangeSupportedDeviceType, isUploadVersion }) => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-y-2 pt-1'>
      {/* Supported Device Label */}
      <div className='flex items-center gap-x-1.5'>
        <span className='text-secondary-500 text-xs font-medium'>
          {t('uploads.form.label.supported_device_type')}
        </span>
        <span>
          <Icon
            name='info'
            toolTip={t('uploads.form.tooltip.supported_device_content')}
            className='text-base text-secondary-500 !block'
          />
        </span>
      </div>

      {/* Supported Device Options */}
      <RadioGroup
        name='usageCount'
        onChange={(event) => onChangeSupportedDeviceType(event?.target?.value)}
        className='py-1 px-1.5 gap-x-8 text-secondary-600'
        value={supportedDeviceType}
        disabled={isUploadVersion}
      >
        {Object.values(SupportedDeviceType).map((item, ind) => {
          const isChecked = supportedDeviceType === item;
          return (
            <Radio
              name='supportedDeviceType'
              value={item}
              checked={isChecked}
              key={ind}
            >
              {t(`uploads.form.label.supported_device_type.${item}`)}
            </Radio>
          );
        })}
      </RadioGroup>
    </div>
  );
};
